import { render, staticRenderFns } from "./allcase.vue?vue&type=template&id=5c4c797c&scoped=true&"
import script from "./allcase.vue?vue&type=script&lang=js&"
export * from "./allcase.vue?vue&type=script&lang=js&"
import style0 from "./allcase.vue?vue&type=style&index=0&id=5c4c797c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c797c",
  null
  
)

export default component.exports